import * as ResultsKnowledge from './resultsKnowledge.js';
export default ResultsKnowledge;
